import { Component } from '@angular/core';
import { FormComponent } from '@jump-tech-frontend/relay/shared';
import { readOnlyServiceToken } from '@jump-tech-frontend/angular-common';

@Component({
    selector: 'relay-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [FormComponent]
})
export class AppComponent {}
